import React from "react";
import Image from "../Images/Founder-1.jpeg";
import "../CSS/Founder.css";
import { FaMedal,  FaTrophy } from 'react-icons/fa'; 
import experiencegif from "../Images/workexperiencegif.gif"

const Achievements=()=>{
    return(
        <>
            <div className="foundersection2">
                <h1 className="p-4 text-center mb-4">Achievements</h1>
                <div className="achievements-container">
                {/* Champions Card */}
                <div className="achievements-card glassmorphism">
                    <h5><FaTrophy /> Champion Titles</h5>
                    <ul>
                        <li><FaTrophy /> SDAT Champion - 4 Times</li>
                        <li><FaTrophy /> Republic Games State Champion</li>
                        <li><FaTrophy /> Divisional Champion - 4 Times</li>
                        <li><FaTrophy /> District Champion - 6 Times</li>
                        <li><FaTrophy /> Zonal Champion - 7 Times (Singles & Doubles)</li>
                        <li><FaTrophy /> Anna University Silver Medalist</li>
                        <li><FaTrophy /> TIES Silver Medalist</li>
                        <li><FaTrophy /> Anna Univ TN State Silver Medalist</li>
                    </ul>
                </div>
                
                {/* Medalists Card */}
                <div className="achievements-card glassmorphism">
                    <h5>Work Experience</h5>
                    <ul>
                        <li><img src={experiencegif} style={{width:"20px"}}/> Worked as coach for 2 years in Dubai</li>
                        <li><img src={experiencegif} style={{width:"20px"}}/> Worked as coach for 5 years in 3 Badminton Academies in Chennai</li>
                        {/* <li><FaMedal /> Anna Univ TN State Silver Medalist</li> */}
                    </ul>
                </div>
            </div>
            </div>
        </>
    );
}

export default Achievements;